module.exports = __webpack_public_path__ + "media/images/riders/MATHIEU_VAN_DER_POEL-930c306c9e9cda2dbcf281727e8d25f2.png";